import { get as getCookie } from 'js-cookie';
import { polyfill } from 'es6-promise';
import { ReportEventUnauthenticatedParams } from './ReportEventUnauthenticatedParams';
import 'whatwg-fetch';

polyfill();

const XSRF_TOKEN_COOKIE_KEY = 'XSRF-TOKEN';
const XSRF_TOKEN_HEADER_KEY = 'X-XSRF-TOKEN';
const VIZPORTAL_WEB_CLIENT_API_PREFIX: string = 'vizportal/api/web/v1';
const VIZPORTAL_WEB_CLIENT_API_METHOD_NAME: string = 'reportEventUnauthenticated';

/**
 * Implementation of a WebClientRequester that uses the fetch API protocols
 */
export class FetchRequester {

  private sendAuthToken: boolean;

  public constructor(private endpoint: string) {
    if (typeof fetch === 'undefined' || typeof Request === 'undefined') {
      throw new Error('The fetch API is not defined in this browser. Try adding a polyfill library like "whatwg-fetch"');
    }

    // Only send the xsrf auth token if we're sending to the default vizportal endpoint
    this.sendAuthToken = this.endpoint === '' ? true : false;
  }

  public send(params: ReportEventUnauthenticatedParams): void {
    const path = `${this.endpoint}/${VIZPORTAL_WEB_CLIENT_API_PREFIX}/${VIZPORTAL_WEB_CLIENT_API_METHOD_NAME}`;

    const init: RequestInit = {
      method: 'POST',
      headers: this.getHeaders(),
      cache: 'default',
      mode: 'cors',
      credentials: 'same-origin',
      body: JSON.stringify({
        method: VIZPORTAL_WEB_CLIENT_API_METHOD_NAME,
        params: params,
      })
    };

    const req = new Request(path, init);
    fetch(req).catch(error => console.error(error));
  }

  public getHeaders(): Headers {
    const head = new Headers({
    'Accept': 'application/json',
    'Content-Type': 'application/json'
    });

    if (this.sendAuthToken) {
      head.append(XSRF_TOKEN_HEADER_KEY, getXsrfToken());
    }

    return head;
  }

}

const getXsrfToken = (): string => getCookie(XSRF_TOKEN_COOKIE_KEY)!;
